<template>
  <v-dialog v-model="dialog" @keydown.esc="cancel" :max-width="props.width">
    <v-card>
      <v-card-title>
        <v-toolbar-title>
          <span class="headline">{{ props.title }}</span>
        </v-toolbar-title>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text v-show="!!props.message">
        <v-flex xs12>
          <p>{{ props.message }}</p>
        </v-flex>
      </v-card-text>

      <v-card-actions>
        <v-btn color="grey" flat="flat" @click.native="cancel">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" depressed dark @click.native="agree">Confirmar exclusão</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      props: {
        title: null,
        message: 'Esta ação é irreversível! Vai remover o item e tudo o que estiver relacionado ao mesmo.',
        width: 450
      }
    }
  },

  methods: {
    open (props) {
      this.dialog = true
      this.props = Object.assign(this.props, props)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    agree () {
      this.resolve(true)
      this.dialog = false
    },

    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
